import React from "react"
import { useDrag } from "muuri-react"
import moment from 'moment'
import _ from 'lodash'
import { formatAddress, getTimestamp, getTimestamp2, trimName } from '../utils'

export const TokenEvents = ({ color, width, height, title, tokenEvents }) => {

  const isDragging = useDrag()
  const shadow = isDragging ? "shadow" : ""

  console.log('tokenEvents', tokenEvents)


  const _insights  = JSON.parse(localStorage.getItem("insights5")) !== null 
                  ? JSON.parse(localStorage.getItem("insights5")) 
                  : []

  if (_insights.length > 0 && tokenEvents !== undefined) {

    const filteredInsights = []

    _insights.map((tweetSetting)=>{
      for (let tw of tokenEvents) {
        if (tw.status === tweetSetting.type && tweetSetting.active) {
          filteredInsights.push(tw)
        }
      }
    })

    let uniqueTokenEvents = [...new Set(filteredInsights)];


  uniqueTokenEvents.sort((a, b) => b.timestamp - a.timestamp);

    // tokenEvents = uniqueTokenEvents
  }

  const unicrypt = msg => {

    let lpAddress = msg['urls'].find(x => x.includes('dextools')).split('https://www.dextools.io/app/ether/pair-explorer/')[1]

    return <a href={'https://app.unicrypt.network/amm/uni-v2/pair/' + lpAddress} target="_blank"><img src="./unicrypt.svg" className="unicrypt" /></a>
  }


  const teamfinance = msg => {

    let lpAddress = msg['urls'].find(x => x.includes('dextools')).split('https://www.dextools.io/app/ether/pair-explorer/')[1]

    return <a href={'https://www.team.finance/view-coin/' + lpAddress} target="_blank"><img src="./team.png" className="teamfinance" /></a>
  }

  const pinksale = msg => {

    let lpAddress = msg['urls'].find(x => x.includes('dextools')).split('https://www.dextools.io/app/ether/pair-explorer/')[1]

    return <a href={'https://www.pinksale.finance/pinklock/detail/' + lpAddress + '?chain=ETH'} target="_blank"><img src="./pinksale.png" className="pinksale" /></a>
  }


console.log('tokenEvents', tokenEvents)

if (tokenEvents !== undefined) {
  let ethEvents = tokenEvents.filter(x => x.platform === 'ethereum') 
console.log('ethEvents', ethEvents)


  let raydiumEvents = tokenEvents.filter(x => x.platform === 'solana') 
console.log('raydiumEvents', raydiumEvents)


  let pumpfunEvents = tokenEvents.filter(x => x.platform === 'pumpfun') 
console.log('pumpfunEvents', pumpfunEvents)


}


  return (
    <div className={`item h${height} w${width} ${color} ${shadow}`}>
      <div className="handle">
        <span className="header">Insights</span> 
        <img src="./dragIcon.png" className="dragIcon" />
      </div>
      <div className="item-content">
        {
          !_.isNil(tokenEvents) && tokenEvents.length > 0
          ? tokenEvents.map(tokenEvent =>
                           <> <div key={tokenEvent.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  {/* Left Side: Name and Address */}
  <div>
                                        <img 
  src={tokenEvent.platform === 'ethereum' ? './ethereum.png' : './solana.png'}
  style={{ width: '20px', position: 'relative', top: '5px', paddingRight: '5px' }} 

/>
    <span style={{ color: 'rgb(0, 218, 255)' }}>{trimName(tokenEvent.name.trim())}</span>
    <span style={{ color: '#7c83f7', marginLeft: '8px' }}>{formatAddress(tokenEvent.address)}</span>
  </div>


  {/* Right Side: Icons and Timestamp */}
  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>


    <span className="ts" style={{ minWidth: '30px', textAlign: 'right' }}>
      {getTimestamp2(tokenEvent.timestamp)}
    </span>
  </div>
</div>


<div style={{color: 'cyan', paddingLeft: '8px', paddingBottom: '5px'}}>




                       ↳ {tokenEvent.signal === 'curve' ? `bonding curve has reached ${tokenEvent.data.curve}%` : tokenEvent.signal === 'dextools_updated' ? 'fast tracked update on Dextools' : tokenEvent.signal === 'trending_safeguard' ? 'trending on SafeGuard' : tokenEvent.signal === 'burned' ? 'burned its liquidity' : tokenEvent.signal === 'kingofthehill' ? 'crowned king of the hill' : tokenEvent.signal === 'trending_buybot' ? 'is trending on BuyBot' : tokenEvent.signal === 'called' ? `called by ${tokenEvent.data.caller}` : tokenEvent.signal === 'snipers' ? `sniped by ${tokenEvent.data.snipers}` : tokenEvent.signal  === 'verified' ? 'is now verified' : tokenEvent.signal === 'initials' ? `added ${tokenEvent.data.amount} initials` : tokenEvent.signal} 

      


                       </div></>)
          : 'Loading Token Events'
        }
      </div>
    </div>
  )
}